import { useEffect, useState } from 'react'

/**
 * Delays a rapidly changing value.
 *
 * Used for the search box so typing does not fire one request per keystroke —
 * on plant wifi that queue of requests is what makes a list feel broken.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}
